import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import type { NpsInfo } from 'v2/interfaces/nps';

import apiService from './api';
import eduzzAccountsService from './eduzzAccount';

import type { ApiService } from './api';
import type { EduzzAccountsService } from './eduzzAccount';

export class NpsService {
  private readonly SITE_ID = 845988;

  constructor(private readonly apiService: ApiService, private readonly eduzzAccountsService: EduzzAccountsService) {}

  getInfo(journey: string) {
    return combineLatest([this.apiService.get<NpsInfo>('/nps/info', { journey }), this.eduzzAccountsService.getUserToolbar()]).pipe(
      map(([info, user]) => ({
        ...info,
        name: user?.name,
      }))
    );
  }

  async getSurveyLastAnswer(surveyId: number) {
    return this.apiService
      .get('/nps/last-answer', {
        site_id: this.SITE_ID,
        survey_id: surveyId,
      })
      .toPromise();
  }
}

export const npsService = new NpsService(apiService, eduzzAccountsService);
